<template>
  <div style="padding:10px;background-color: #F5F5F5;min-height: 100%">

    <Card :bordered="false" :dis-hover="true" style="margin-bottom:10px;">
      <div style="text-align:left">
        <Row>
          <Col span="19">
            <Button type="primary" @click="addb">增加</Button>
            <Button type="success" @click="gennow">立即生成</Button>
            <Button type="info" @click="down">批量下载当前页</Button>
            <cite>|</cite>变量说明：课程标题
            <Tag>#title#</Tag>
            ，课程价格
            <Tag>#price#</Tag>
            ，4个课程场次分别是：
            <Tag>#cc1#、#cc2#、#cc3#、#cc4#</Tag>
            待生成的视频每天凌晨处理
          </Col>
          <Col span="5">
            <Input search enter-button placeholder="输入编号搜索" v-model="serch.key" @on-search="load"/>
          </Col>
        </Row>
      </div>
    </Card>

    <Card :dis-hover="true">
      <Spin fix v-if="loading"></Spin>
      <el-table border :data="list" size="small" style="width: 100%">
        <el-table-column prop="id" label="编号" width="60"></el-table-column>
        <el-table-column prop="name" label="视频模板模板" :show-tooltip-when-overflow="true"></el-table-column>
        <!--        <el-table-column prop="json" label="生成配置" :show-tooltip-when-overflow="true"></el-table-column>-->
        <el-table-column prop="ctime" label="创建时间" :show-tooltip-when-overflow="true"></el-table-column>
        <el-table-column prop="gtime" label="最后生成时间" :show-tooltip-when-overflow="true"></el-table-column>
        <el-table-column prop="state" label="生成状态" :show-tooltip-when-overflow="true">
          <template slot-scope="scope">
            <span v-if="scope.row.state==='生成完成'">
              <a target="_blank" :href="'/api/mp4tool/download?uuid='+scope.row.fid">已完成，点击下载</a>
<!--              <cite>|</cite>-->
<!--              <a @click="reload(scope.row.id)">重新生成</a>-->
            </span>
            <span v-else v-html="scope.row.state"></span>
          </template>
        </el-table-column>

        <el-table-column prop="msg" label="操作" width="150" fixed="right">
          <template slot-scope="scope">
            <a @click="peizhi(scope.row)">配置</a>
            <cite>|</cite>
            <a @click="edit(scope.row.id)">编辑</a>
            <cite>|</cite>
            <a @click="remove(scope.row.id)">删除</a>
          </template>
        </el-table-column>
      </el-table>
    </Card>

    <Card :bordered="false" dis-hover style="text-align: center;margin-top:10px">
      <Page :total="count" show-total :page="page" @on-page-size-change="limitChange" show-elevator @on-change="change"
            show-sizer :page-size-opts="[10, 30,50,100]"></Page>
    </Card>

    <Modal
      v-model="modal1"
      title="增加或编辑"
      @on-ok="save"
      @on-cancel="cancel">
      <Form :label-width="100">
        <FormItem label="视频模板模板" required>
          <UploadUUID v-model="detail.fid"></UploadUUID>
        </FormItem>
        <FormItem label="配置">
          <Input v-model="detail.json"></Input>
          <p v-if="!detail.id">增加会直接读取默认配置，可无需修改直接保存。</p>
        </FormItem>
      </Form>
    </Modal>

    <Modal
      v-model="m2.modal"
      title="模板配置"
      width="650"
      :mask-closable="false"
      @on-ok="save2">

      <Button size="small" style="margin-bottom: 10px" @click="show1=!show1">开启/关闭编辑模式</Button>
      <Card :title="'课程变量'+(index+1)" dis-hover style="margin-bottom: 20px" v-for="(item,index) in jsonList">
        <Form :label-width="100">
          <FormItem label="选择课程" required>
            <Select :transfer="true" :clearable="true" filterable placeholder="选择课程（可搜索）" v-model="item.ppid">
              <Option v-for="item in clist" :value="item.PP_ID" :label="item.PP_NAME"></Option>
            </Select>
          </FormItem>
          <Divider v-if="show1"/>
          <template v-for="b in item.blist" v-if="show1">
            <FormItem label="文本内容">
              <Input type="text" v-model="b.text"/>
            </FormItem>
            <FormItem label="文本信息">
              X:<Input type="number" style="width: 70px" v-model="b.x"/>
              <cite>|</cite>
              Y:<Input type="number" style="width: 70px" v-model="b.y"/>
              <cite>|</cite>
              字体大小:<Input type="number" style="width: 55px" v-model="b.fontSize"/>
              <cite>|</cite>
              字体颜色:
              <ColorPicker v-model="b.fontColor"/>
            </FormItem>
            <Divider/>
          </template>
          <div style="text-align: center" v-if="show1">
            <a @click="addbl(index)">增加文本</a>
            <cite>|</cite>
            <a @click="removeKong(index)">删除文本为空的变量</a>
          </div>
        </Form>
      </Card>
      <Button type="success" @click="addkcbl">增加课程变量</Button>
    </Modal>

  </div>
</template>

<script>
import UploadUUID from "../../public/upload/UploadUUID.vue";

export default {
  components: {UploadUUID},
  data() {
    return {
      baseUrl: '/api/mp4tool/',
      list: [],
      page: 1,
      count: 0,
      limit: 10,
      modal1: false,
      detail: {},
      serch: {
        key: ''
      },
      loading: false,
      m2: {
        modal: false,
        id: 0
      },
      jsonList: [//配置信息
        {ppid: 0, blist: [{text: '', x: 0, y: 0, fontSize: 24, fontColor: '#FFFFFF'}]}
      ],
      clist: [], //课程信息
      show1: false,
      bl: '',//默认配置
    }
  },
  methods: {
    down(){
      this.$Modal.confirm({
        title: '系统提示',
        content: '确定要下载当前页展示的'+this.list.length+'条数据吗',
        onOk: () => {
          for(let i = 0;i<this.list.length;i++){
            window.open('/api/mp4tool/download?uuid='+this.list[i].fid);
          }
        },
      });
    },
    gennow() {
      this.$Modal.confirm({
        title: '系统提示',
        content: '确定要开始生成视频吗',
        onOk: () => {
          let that = this;
          this.$Message.info('已开始生成');
          this.$axios.get(this.baseUrl + 'gennow').then(function (rs) {
            that.toast(rs.data);
          });
        },
      });
    },
    addb() {
      this.modal1 = true;
      this.detail = {};
      this.detail.json = JSON.stringify(this.bl);
    },
    peizhi(row) {
      this.m2.modal = true;
      this.m2.id = row.id;
      if (row.json) {
        this.jsonList = JSON.parse(row.json);
      } else {
        this.jsonList = [{ppid: 0, blist: [{text: '', x: 0, y: 0, fontSize: 24, fontColor: '#FFFFFF'}]}];
      }
    },
    save2() {//保存数据
      let d = {
        json: this.jsonList,
        id: this.m2.id
      };
      let that = this;
      this.$axios({url: this.baseUrl + 'savepeizhi', method: 'post', data: d}).then(function (rs) {
        that.toast(rs.data);
      });
    },
    removeKong(index) {//删除文本为空的变量
      // this.jsonList[index].blist = [];
      let arr = [];
      for (let i = 0; i < this.jsonList[index].blist.length; i++) {
        if (this.jsonList[index].blist[i].text) {
          arr.push(this.jsonList[index].blist[i]);
        }
      }
      this.jsonList[index].blist = arr;
    },
    addbl(index) {//增加文本变量
      this.jsonList[index].blist.push({text: '', x: 0, y: 0, fontSize: 24, fontColor: '#FFFFFF'});
    },
    addkcbl() {
      this.jsonList.push({ppid: 0, blist: [{text: '', x: 0, y: 0, fontSize: 24, fontColor: '#FFFFFF'}]});
    },
    load() {
      let that = this;
      let params = [];
      if (this.serch.key) {
        params.push('t.id@=@' + this.serch.key);
      }
      that.loading = true;
      this.$axios.get(this.baseUrl + 'findall?page=' + this.page + '&limit=' + this.limit + '&params=' + params).then(function (rs) {
        that.list = rs.data.data;
        that.count = rs.data.count;
        that.loading = false;
      });
    },
    limitChange(val) {
      this.limit = val;
      this.load();
    },
    change(val) {
      this.page = val;
      this.load();
    },
    save() {
      let that = this;
      let data = Object.assign({}, this.detail);
      this.$axios({url: this.baseUrl + 'save', method: 'post', data: this.$qs.stringify(data)}).then(function (rs) {
        that.toast(rs.data);
        if (rs.data.success) {
          that.detail = {};
        }
      });
    },
    edit(id) {
      let that = this;
      this.$axios.get(this.baseUrl + 'getById?id=' + id).then(function (rs) {
        that.detail = rs.data;
        that.modal1 = true;
      });
    },
    remove(id) {
      this.$Modal.confirm({
        title: '系统提示',
        content: '确定要删除吗',
        onOk: () => {
          let that = this;
          this.$axios.get(this.baseUrl + 'delete?ids=' + id).then(function (rs) {
            that.toast(rs.data);
          });
        },
      });
    },
    reload(id) {
      this.$Modal.confirm({
        title: '系统提示',
        content: '确定要重新生成视频吗？请勿在视频下载过程中重新生成视频',
        onOk: () => {
          let that = this;
          this.$axios.get(this.baseUrl + 'reload?id=' + id).then(function (rs) {
            that.toast(rs.data);
          });
        },
      });
    },
    loadlist() { //加载课程列表
      let that = this;
      this.$axios.get('/api/v1/product/getCourseList').then(function (rs) {
        that.clist = rs.data;
      });

      //加载默认变量
      this.$axios.get('/api/mp4tool/getmorenbl').then(function (rs) {
        that.bl = rs.data;
      });
    },
    toast(data) {
      if (data.success) {
        this.load();
        this.$Message.success(data.msg);
      } else {
        this.$Message.error(data.msg);
      }
    }
  },
  created() {
    this.load();
    this.loadlist();
  }
}
</script>



// WEBPACK FOOTER //
// src/components/mp4tool/Mp4Tool.vue